module.exports = __webpack_public_path__ + "img/b.32138af1.png";